// frontend/src/components/GrowthWorkspace.jsx
// Version: 3.0 (quick-260916-wll — офисы из держателя, литералы канона убраны)
//
// 🔴 ЧТО УБРАНО 17.09.2026 — ПЯТАЯ КОПИЯ КАНОНА. Здесь лежал массив офисов
//    «по умолчанию»: боевые UUID профилей, адреса, телефон, имя адвоката и
//    ссылки на карты. Живые данные лишь НАКРЫВАЛИ этот массив сверху —
//    разворачиванием объекта с запасным значением на каждое поле.
//    ЛИТЕРАЛ БЫЛ ОСНОВОЙ карточки: любое поле, которого нет в ответе, молча
//    показывалось из вёрстки, и отличить на экране «пришло с сервера» от
//    «написано здесь» было НЕЛЬЗЯ. Тот же дефект, что подстановка в `catch`,
//    только без `catch` — и потому ещё незаметнее.
//    Третий офис в этом массиве НЕ СУЩЕСТВУЕТ ВООБЩЕ (подтверждено владельцем).
//
// 🔴 ОТКУДА ОФИСЫ ТЕПЕРЬ: ручка `GET /api/v1/ofisy/` — единственный держатель
//    (`backend/app/services/ofisy.py`), форма ответа `{ofisy, vsego}`.
//    В карточку идёт `adres_naruzhu`, а не `adres_vnutri`, и вот почему: с
//    этих карточек открывается пульт GMB, то есть карточка ВЕДЁТ К ПУБЛИКАЦИИ
//    на площадке Google. ЧТО ИМЕННО можно опубликовать, решает канон поофисно
//    через `ulica_publichna`, и вид адреса обязан быть тем, который канон
//    разрешает наружу, — каковы бы ни были признаки сегодня. Молчаливое
//    допущение в любую сторону — дефект.
//
// 🔴 ОТКАЗ ДЕРЖАТЕЛЯ (503) И ПУСТОЙ СПИСОК — РАЗНЫЕ СОСТОЯНИЯ МИРА, и на
//    экране они выглядят по-разному. Слить их значит сказать «офисов нет»
//    там, где их не смогли прочитать.
// Description: Центр роста и репутации практики Fitenko Law PLLC: Marketing Pulse,
//              Reputation & Public Trust, Citations, Office Profiles.
//
// 🔴 ЧТО УБРАНО 15.09.2026. Экран показывал ИЗМЕРЕНИЯ, которых никто не делал:
//    конверсии по каналам («calls: 72, paid: 34, conversion: 47.2»), кривые
//    лидов за 30 и 90 дней, сводку «138 обращений · 62 записи · 44,9 % · пайплайн
//    $21 700», AI Health 99 из 100, «1 из 72 сигналов», «99,2 % · +0,7 %»,
//    точность NAP по офисам и число отзывов в Google. Ни одно из этих чисел
//    ниоткуда не бралось — они были НАПИСАНЫ.
//
// 🔴 ХУЖЕ ЧИСЕЛ БЫЛИ ОБЕЩАНИЯ ДЕЙСТВИЙ. «Run Full Audit» крутил таймер и
//    рапортовал о завершённой проверке 72 сигналов, не обратившись ни к одной
//    ручке. «Execute Automated Fix» сообщал, что схема выкачена в JSON-LD
//    главной страницы сайта, ничего никуда не выкатив. Возврат из Google OAuth
//    печатал «подключено», НЕ СПРОСИВ, подключено ли.
//    Прежние формулировки здесь НЕ ЦИТИРУЮТСЯ дословно: их стережёт
//    `__tests__/vydumannaya-faktura.test.js`.
//    Сообщение об исходе, написанное до исхода, — не сообщение
//    ([[knowledge_promise_is_not_a_gate]]).
//
// 🔴 ЧЕМ ЗАМЕНЕНО: честное «источника нет» на месте каждого числа и ФАКТИЧЕСКИЙ
//    исход ручки на месте заранее написанного успеха. Ручек бэкенда эта задача
//    не изобретает: где источника нет, там и написано, что его нет.
//
// 🔴 ЧТО ПОЛУЧИЛО ЖИВОЙ ИСТОЧНИК 16.09.2026 (quick-260916-udw): ЧЕТЫРЕ карточки
//    верхнего ряда вкладки «Reputation & Trust» — `nap-i-citaty`, `open-issues`,
//    `entity-status`, `nap-baseline`. Они читают готовый отчёт
//    `GET /api/v1/reputation/full-audit/latest` и показывают ТОЛЬКО то, что в нём
//    есть: индекс NAP со своим знаменателем, цитаты нейросетей со своим,
//    длину и разбивку `prescriptions`, число канонических локаций, а также
//    метод, момент и возраст замера.
//
// 🔴 ЧТО ИЗМЕНИЛОСЬ 17.09.2026 (quick-260917-28c). Прежняя строка выше
//    утверждала, что метод, момент и возраст стоят НА КАЖДОЙ из четырёх
//    карточек. Это было правдой и было дефектом: один и тот же технический
//    блок («метод / момент / возраст записи: NNNN с») повторялся четырежды и
//    читался как вывод отладочного журнала. Подпись НЕ УБРАНА — она сведена в
//    ОДНУ плашку `[data-podpis-zamera]` над рядом и переведена в человеческий
//    вид, оставшись при этом СВЕРЯЕМОЙ: точный момент из ответа лежит в
//    `dateTime`/`title`, точные секунды — в `data-vozrast-sek`. Человек читает
//    пересказ, проверяющий — исходное значение; ни одно из двух не потеряно.
//
// 🔴 ЧТО ПОЛУЧИЛО ИЗОБРАЖЕНИЕ И ПО КАКОМУ ПРАВИЛУ (там же, 17.09.2026). У
//    четырёх величин верхнего ряда появились полосы, и НИ ОДНОЙ НОВОЙ ВЕЛИЧИНЫ
//    при этом не заведено: ни дат, ни кривых «за 30 дней», ни стрелок роста.
//    Ширина каждой полосы ВЫЧИСЛЯЕТСЯ из числа ответа — другой отчёт даёт
//    другую ширину; записанная руками ширина запрещена, потому что расходится
//    с величиной молча.
//    🔴 ОГРАНИЧЕНИЕ 0..100 ОТНОСИТСЯ К ПОЛОСЕ И НИКОГДА К ЧИСЛУ. Пришло 140 —
//    человек видит 140, полоса упирается в 100, и расхождение НАЗВАНО подписью:
//    молча ограниченная полоса рядом с числом 140 читалась бы как «так и надо».
//    🔴 Три исхода арифметики различимы ПОРОЗНЬ: «величины в ответе нет»,
//    «делить не на что» и «измеренный ноль» — разные положения дел, и слить их
//    значило бы сказать «измерено и вышло ноль» там, где измерения не было.
//
// 🔴 ЧЕГО ЗДЕСЬ ВСЁ ЕЩЁ НЕТ (названо вслух, чтобы не считалось сделанным):
//    живого источника НЕТ у всего остального на этом экране — у Marketing Pulse,
//    у блока офисов, у журнала проверок и у кривых спроса. Прежнее утверждение
//    «источника нет ни для одной цифры» после этой правки ЛОЖНО для четырёх
//    названных карточек и остаётся ИСТИННЫМ для остальных блоков.
//
// 🔴 ЧЕГО НЕ ПОЯВИЛОСЬ: сводного «скора репутации» (отчёт не содержит его
//    НАРОЧНО — `full_audit_orchestrator.py:548-552`) и второй точки платного
//    запуска: `POST /full-audit/run` на этом экране ровно один — внутри
//    `FullAuditModal`, за его собственными воротами.

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
  TrendingUp,
  ShieldCheck,
  Award,
  MapPin,
  PhoneCall,
  MessageSquare,
  Users,
  Search,
  ExternalLink,
  CheckCircle2,
  AlertTriangle,
  Play,
  Sparkles,
  Globe,
  Sliders,
  ChevronRight,
  Info,
  Swords,
  FileText,
  BarChart3,
  Building,
  Zap,
  Bot
} from 'lucide-react';
import { GmbCommandModal } from './reputation/GmbCommandModal';
import CitationsWorklist from './reputation/CitationsWorklist';
import FullAuditModal from './reputation/FullAuditModal';

// 🔴 ЕДИНАЯ НАДПИСЬ ТАМ, ГДЕ ЖИВОГО ИСТОЧНИКА НЕТ. Одна на весь экран: два
// разных текста об одном и том же читаются как два разных положения дел.
const ISTOCHNIKA_NET = 'Источника нет: эта величина не измеряется — ручки, которая бы её выдала, не существует.';
const NET_CHISLA = '—';

// Каналы привлечения. 🔴 ОСТАЛИСЬ ТОЛЬКО НАЗВАНИЯ: числа звонков, оплат и
// конверсии («calls: 72, paid: 34, conversion: 47.2») были написаны руками и
// показывались как замер, а короткие «insight» — как вывод из этого замера.
const KANALY = [
  { id: 'voice', name: 'AI Voice (Sofia)', icon: PhoneCall },
  { id: 'maps', name: 'Google Maps', icon: MapPin },
  { id: 'referrals', name: 'Referrals & Attorney Network', icon: Users },
  { id: 'chat', name: 'Website Chat (Katifi)', icon: MessageSquare }
];

// 🔴 СПИСОК СПРАВОЧНИКОВ БОЛЬШЕ НЕ ЗАШИТ В ФАЙЛ. Здесь стояли три записи
// Google Business Profile с адресами офисов (в том числе НЕСУЩЕСТВУЮЩЕГО) и
// ссылками на карты, и запись реестра Florida Bar с именем адвоката и номером.
//
// Записи GMB теперь строятся из ответа держателя офисов — по одной на КАЖДЫЙ
// офис канона, и ни одной сверх.
//
// 🔴 ЗАПИСЬ РЕЕСТРА FLORIDA BAR УБРАНА, А НЕ ПЕРЕНЕСЕНА, И ЭТО НАЗВАНО ВСЛУХ:
// имя адвоката и номер допуска — канон, но ДЕРЖАТЕЛЯ этого канона в коде НЕТ
// (в `ofisy.json` таких полей нет по построению). Правило: канон берётся у
// держателя или не берётся вовсе; вторая копия расходится с оригиналом молча.
// Завести держателя реестровых сведений — отдельная работа с владельцем, она
// записана в отложенное, а не выдана за сделанную.

// 🔴 МЕТОД, МОМЕНТ И ВОЗРАСТ ЗАМЕРА — ОДИН РАЗ НА ВЕСЬ РЯД (ПРАВИЛО НОЛЬ §4:
// число без указания, чем и когда оно получено, читается как текущее).
// Возраст берётся ТОЛЬКО у сервера (`cache_age_seconds` считается в момент
// ответа, `full_audit_orchestrator.py:301-303`): свой второй счёт по часам
// браузера разошёлся бы с первым молча.

/**
 * Человеческий вид момента по часам UTC. 🔴 Собирается ДЕТЕРМИНИРОВАННО из
 * частей (`getUTC*`), а НЕ `toLocaleString`: локаль и пояс браузера сделали бы
 * показанное несравнимым с тем, что лежит в ответе. Часы НАЗВАНЫ подписью
 * `UTC` — дефект, который в бэкенде лечили полями `snapshot_clock`/`snapshot_tz`
 * (`full_audit_orchestrator.py:363-376`), был не в расхождении часов, а в
 * отсутствии подписи, по каким часам взята дата.
 * 🔴 Не привелось к дате — возвращается `null`, и наверх уходит ИСХОДНАЯ строка:
 * `Invalid Date` на экране выглядел бы как дата, которой никто не получал.
 */
const chelovecheskijMomentUTC = (syroj) => {
  if (typeof syroj !== 'string' || !syroj) return null;
  const d = new Date(syroj);
  if (Number.isNaN(d.getTime())) return null;
  const dv = (n) => String(n).padStart(2, '0');
  return `${dv(d.getUTCDate())}.${dv(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}, `
    + `${dv(d.getUTCHours())}:${dv(d.getUTCMinutes())} UTC`;
};

/**
 * Человеческое округление возраста записи. Точное значение НЕ теряется: оно
 * остаётся на узле в `title` и `data-vozrast-sek`, поэтому показанное можно
 * сверить с ответом. Тильда обязательна — округлённое не выдаётся за точное.
 */
const chelovecheskijVozrast = (sek) => {
  if (typeof sek !== 'number' || !Number.isFinite(sek)) return null;
  const drob = (x) => x.toFixed(1).replace('.', ',');
  if (sek < 60) return `${Math.round(sek)} с`;
  if (sek < 3600) return `${Math.round(sek / 60)} мин`;
  if (sek < 86400) return `${drob(sek / 3600)} ч`;
  return `${drob(sek / 86400)} сут`;
};

const PodpisZameraEdinaya = ({ otvet, nap }) => {
  if (!otvet) return null;
  const metod = nap && nap.measured_method === 'human_screenshot'
    ? 'снимки экрана, сверенные человеком'
    : 'метод замера не назван';
  const momentSyroj = (otvet.storage === 'tenant_file'
    ? (otvet.cache_written_at || otvet.completed_at)
    : otvet.completed_at) || 'момент не назван';
  const momentChelovechnyj = chelovecheskijMomentUTC(momentSyroj);
  const vozrast = chelovecheskijVozrast(otvet.cache_age_seconds);
  return (
    <div
      data-podpis-zamera="1"
      className="bg-white border border-[#E5E1D6] rounded-2xl px-5 py-3 shadow-xs text-xs text-[#687077] leading-relaxed flex flex-wrap items-center gap-x-2 gap-y-1"
    >
      <Info className="w-3.5 h-3.5 text-[#C8A653] shrink-0" />
      <span className="text-[#20231F]">Аудит зафиксирован:</span>
      {momentChelovechnyj ? (
        <time
          dateTime={momentSyroj}
          title={momentSyroj}
          className="text-[#20231F] font-semibold"
        >
          {momentChelovechnyj}
        </time>
      ) : (
        <span className="text-[#20231F]">
          <span className="font-semibold">{momentSyroj}</span>
          {' '}
          <span className="text-[#687077]">
            (момент в разборчивый вид не привёлся: показан как есть)
          </span>
        </span>
      )}
      <span className="text-[#E5E1D6]">·</span>
      <span>метод: {metod}</span>
      <span className="text-[#E5E1D6]">·</span>
      {vozrast ? (
        <span
          data-vozrast-sek={otvet.cache_age_seconds}
          title={`точное значение: ${otvet.cache_age_seconds} с; посчитан сервером при ответе`}
        >
          запись обновлена ~{vozrast} назад
        </span>
      ) : (
        <span>ответ собран из памяти процесса (storage: in_process_only)</span>
      )}
    </div>
  );
};

// ── АРИФМЕТИКА ШКАЛ: ОДИН помощник на все индикаторы ─────────────────────────
// 🔴 ПОЧЕМУ ОДИН. Второй счёт той же доли разошёлся бы с первым МОЛЧА, и на
//    экране оказались бы две величины, называющие себя одним именем.
//
// 🔴 ПОЧЕМУ ВОЗВРАЩАЕТСЯ ИСХОД, А НЕ ЧИСЛО. Исходов три, и к числу они не
//    сводятся: «величины нет», «делить не на что» и «измеренный ноль» — разные
//    положения дел, и слить их значило бы сказать «измерено и вышло ноль» там,
//    где измерения не было. Различие обязано доехать до экрана целым.
//
// 🔴 `chislo` И `shirina` — РАЗНЫЕ ПОЛЯ НАРОЧНО. Ограничение 0..100 относится к
//    ИЗОБРАЖЕНИЮ полосы и НИКОГДА к печатаемому числу: `chislo` уходит наверх
//    ровно тем, чем пришло с сервера. Подменить печатаемое подогнанным значит
//    спрятать поломку прибора ровно там, где человек мог бы её заметить.
const SHKALA_MAX = 100;

const dolyaDlyaShkaly = (velichina, delitel) => {
  if (!Number.isFinite(velichina)) return { vid: 'net', prichina: 'net-velichiny' };
  const estDelitel = delitel !== undefined;
  if (estDelitel && (!Number.isFinite(delitel) || delitel === 0)) {
    return { vid: 'net', prichina: 'net-znamenatelya' };
  }
  const dolya = estDelitel ? (velichina / delitel) * 100 : velichina;
  // Округляется ТОЛЬКО доля для ширины: десятая доля процента полосы не видна,
  // а печатаемое число не округляется вовсе.
  const okruglennaya = Math.round(dolya * 10) / 10;
  let shirina = okruglennaya;
  let vneShkaly = null;
  if (okruglennaya > SHKALA_MAX) {
    shirina = SHKALA_MAX;
    vneShkaly = 'verh';
  } else if (okruglennaya < 0) {
    shirina = 0;
    vneShkaly = 'niz';
  }
  return {
    vid: 'est',
    chislo: velichina,
    dolya: okruglennaya,
    shirina,
    vneShkaly,
    nolIzmeren: okruglennaya === 0,
  };
};

// Подписи исхода «полосы нет»: причины РАЗНЫЕ, и текст у них разный.
const PODPIS_NET_SHKALY = {
  'net-velichiny': 'величины в ответе нет',
  'net-znamenatelya': 'доли нет: знаменатель ноль — делить не на что',
};

/**
 * Полоса индикатора. 🔴 Ширина ВЫЧИСЛЯЕТСЯ инлайновым стилем из величины
 * ответа. Записанная руками ширина — что в стиле, что классом Tailwind —
 * запрещена: она разойдётся с величиной молча, и первым это увидит клиент.
 * 🔴 Образцы запрещённых написаний здесь НЕ ЦИТИРУЮТСЯ дословно нарочно: их
 * ищет по файлу поиск-прибор ворот, и дословная цитата в прозе даёт ему
 * ложное красное — прибор не отличает пример от дефекта.
 * Исход `net` — заполнителя НЕТ ВООБЩЕ: пустая полоса рядом с прочерком
 * читалась бы как измеренный ноль.
 */
const Polosa = ({ itog, imya }) => {
  if (!itog) return null;
  if (itog.vid === 'net') {
    return (
      <div className="flex items-baseline gap-1.5 text-[10px] text-[#687077] leading-relaxed">
        <span className="text-sm text-[#20231F]">{NET_CHISLA}</span>
        <span>{PODPIS_NET_SHKALY[itog.prichina]}</span>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      <div className="h-1.5 w-full bg-[#F1EEE4] rounded-full overflow-hidden">
        <div
          data-shkala={imya}
          data-vne-shkaly={itog.vneShkaly || undefined}
          data-nol-izmeren={itog.nolIzmeren ? '1' : undefined}
          style={{ width: `${itog.shirina}%` }}
          className={`h-full rounded-full ${itog.vneShkaly ? 'bg-[#A35B2A]' : 'bg-[#C8A653]'}`}
        />
      </div>
      {itog.nolIzmeren && (
        <div className="text-[10px] text-[#687077] leading-relaxed">измеренный ноль</div>
      )}
      {itog.vneShkaly === 'verh' && (
        <div className="text-[10px] text-[#A35B2A] leading-relaxed">
          полоса упёрлась в 100: величина из ответа больше шкалы (показана как есть)
        </div>
      )}
      {itog.vneShkaly === 'niz' && (
        <div className="text-[10px] text-[#A35B2A] leading-relaxed">
          полоса на нуле: величина из ответа меньше шкалы (показана как есть)
        </div>
      )}
    </div>
  );
};

export const GrowthWorkspace = ({
  profiles = [],
  stats = {},
  onOpenSourceOfTruth,
  onOpenAgentBattle,
  onOpenAnalytics,
  onImproveLocation
}) => {
  const [activeTab, setActiveTab] = useState('reputation'); // 'marketing' | 'reputation' | 'citations' | 'locations'
  const [timeframe, setTimeframe] = useState('30d'); // '30d' | '90d'
  const [metricType, setMetricType] = useState('leads'); // 'leads' | 'booked' | 'organic'
  const [selectedGmbOffice, setSelectedGmbOffice] = useState(null);
  const [isGmbModalOpen, setIsGmbModalOpen] = useState(false);
  const [gmbAuthStatus, setGmbAuthStatus] = useState({ connected: false, has_gmb_scope: false });

  // ── Офисы арендатора: ЕДИНСТВЕННЫЙ ДЕРЖАТЕЛЬ `GET /api/v1/ofisy/` ─────────
  // 🔴 ТРИ ВЕЛИЧИНЫ, А НЕ ОДНА. `ofisy === null` — ещё не спрашивали или
  //    спросить не удалось; `ofisy === []` — спросили, и офисов у арендатора
  //    НЕТ (законный ответ: у mlg файла канона нет и быть не должно);
  //    `ofisyOtkaz` — держатель ОТКАЗАЛ (503, канон не прочитан). Свести
  //    отказ и пустоту в одно состояние значит сказать «офисов нет» там, где
  //    их не смогли прочитать.
  const [ofisy, setOfisy] = useState(null);
  const [ofisyOtkaz, setOfisyOtkaz] = useState(null);
  const [ofisyZagruzka, setOfisyZagruzka] = useState(true);

  useEffect(() => {
    let zhiv = true;
    axios.get('/api/v1/ofisy/')
      .then((res) => {
        if (!zhiv) return;
        setOfisy(Array.isArray(res.data?.ofisy) ? res.data.ofisy : []);
        setOfisyOtkaz(null);
      })
      .catch((err) => {
        if (!zhiv) return;
        setOfisy(null);
        setOfisyOtkaz(
          (err && err.response && err.response.data && err.response.data.detail)
          || (err && err.message)
          || 'причина не названа'
        );
      })
      .finally(() => { if (zhiv) setOfisyZagruzka(false); });
    return () => { zhiv = false; };
  }, []);

  // ── Последний ЗАВЕРШЁННЫЙ замер: `GET /full-audit/latest` ─────────────────
  // 🔴 Три величины, а не одна: отказ САМОГО запроса (сеть, 401) — это НЕ
  // «замеров не было», и свалить их в одно состояние значит потерять различие.
  const [otchetOtvet, setOtchetOtvet] = useState(null);
  const [zagruzka, setZagruzka] = useState(true);
  const [otkazZaprosa, setOtkazZaprosa] = useState(null);

  const zaprositPosledniy = useCallback(async () => {
    setZagruzka(true);
    try {
      const res = await axios.get('/api/v1/reputation/full-audit/latest?tenant=fitenko');
      setOtchetOtvet(res.data || null);
      setOtkazZaprosa(null);
    } catch (err) {
      setOtchetOtvet(null);
      setOtkazZaprosa((err && err.message) || 'причина не названа');
    } finally {
      setZagruzka(false);
    }
  }, []);

  useEffect(() => {
    // 🔴 Только GET. Ни одного платного прогона отсюда не уходит.
    zaprositPosledniy();
  }, [zaprositPosledniy]);

  useEffect(() => {
    // Check if redirected from Google OAuth callback
    const params = new URLSearchParams(window.location.search);
    const googleAuth = params.get('google_auth');
    if (googleAuth === 'success') {
      // 🔴 Раньше здесь печаталось «успешно подключен! …авторизован для прямой
      //    публикации», причём с адресом почты — БЕЗ ЕДИНОЙ ПРОВЕРКИ. Признак
      //    `google_auth=success` приходит СТРОКОЙ В АДРЕСЕ и говорит лишь о том,
      //    что нас вернули; подключено ли и с каким правом — знает ручка
      //    состояния. Спрашиваем ЕЁ и говорим то, что ответила она.
      window.history.replaceState({}, document.title, window.location.pathname);
      axios.get('/api/v1/reputation/gmb/auth/status')
        .then((res) => {
          const sostoyanie = res.data || {};
          setGmbAuthStatus(sostoyanie);
          if (sostoyanie.connected && sostoyanie.has_gmb_scope) {
            toast.success('Google Business Profile подключён: право на публикацию подтверждено ручкой состояния.', { duration: 7000 });
          } else if (sostoyanie.connected) {
            toast('Google подключён, но права на публикацию в Business Profile ручка НЕ подтвердила.', { icon: '⚠️', duration: 7000 });
          } else {
            toast.error('Вернулись из Google, но ручка состояния подключения НЕ подтвердила. Считайте, что не подключено.', { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error(`Вернулись из Google, но проверить подключение не удалось: ${(err && err.message) || 'причина не названа'}. Состояние НЕИЗВЕСТНО.`, { duration: 7000 });
        });
    } else if (googleAuth === 'error') {
      const detail = params.get('detail') || 'Не удалось завершить авторизацию Google.';
      toast.error(`Ошибка авторизации Google: ${detail}`, { duration: 6000 });
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const checkGmbAuth = async () => {
      try {
        const res = await axios.get('/api/v1/reputation/gmb/auth/status');
        if (res.data) {
          setGmbAuthStatus(res.data);
        }
      } catch (err) {
        console.warn('Failed to fetch GMB auth status:', err);
      }
    };
    checkGmbAuth();
  }, []);


  // Главный профиль для быстрых переходов.
  // 🔴 ЗДЕСЬ БЫЛ ЗАШИТ БОЕВОЙ UUID и, в хвосте `||`, ЦЕЛЫЙ ВЫДУМАННЫЙ ОБЪЕКТ
  //    профиля с адресом и ссылкой на карты: кнопки открывали окна с профилем,
  //    которого в системе может не быть вовсе. Нет профиля — `null`, и кнопки
  //    выключаются с честной подписью.
  const mainProfile = useMemo(() => {
    return profiles.find(p => p.is_main) || profiles[0] || null;
  }, [profiles]);

  const netProfilya = 'Профилей нет: открывать нечего. Список профилей приходит пропом `profiles`.';

  // ── Карточки офисов: КАНОН ДЕРЖАТЕЛЯ, а не литерал ───────────────────────
  // 🔴 Литерал больше не является основой карточки: если держатель не ответил,
  //    карточек НЕТ ВООБЩЕ, а не «есть, но из вёрстки».
  // 🔴 Держатель офисов и список профилей отвечают на РАЗНЫЕ вопросы: «где
  //    фирма сидит» против «какие профили заведены в системе». Поэтому офис
  //    рисуется из канона, а идентификатор для перехода в пульт GMB берётся
  //    ТОЛЬКО из `profiles`; совпадения нет — переход недоступен, и это честно
  //    (у офиса канона нет UUID профиля по построению).
  const officeList = useMemo(() => {
    if (!ofisy) return [];
    return ofisy.map((o) => {
      const gorodNizhnij = String(o.gorod || '').toLowerCase();
      const profil = profiles.find((p) => {
        const gde = [p.location_name, p.address].filter(Boolean).join(' ').toLowerCase();
        return gorodNizhnij && gde.includes(gorodNizhnij);
      }) || null;
      return {
        kluch: o.kluch,
        nazvanie: o.nazvanie,
        company_name: o.firma,
        location_name: [o.gorod, o.shtat].filter(Boolean).join(', '),
        // 🔴 ПУБЛИЧНЫЙ вид адреса: с этой карточки открывается пульт GMB, то
        //    есть она ведёт к ПУБЛИКАЦИИ на площадке Google.
        address: o.adres_naruzhu,
        phone: o.telefon,
        sayt: o.sayt,
        is_main: !!o.glavnyy,
        badge: o.glavnyy ? 'Главный офис канона' : 'Филиал',
        profileId: profil ? profil.id : null,
        gmb_url: (profil && profil.gmb_url) || null,
      };
    });
  }, [ofisy, profiles]);

  /**
   * Состояние держателя офисов словами. 🔴 Три исхода и три РАЗНЫХ текста:
   * «ещё не спросили», «спросить не удалось» и «офисов нет». Совпади тексты —
   * «не смогли прочитать» читалось бы как «нет».
   */
  const SostoyanieOfisov = () => {
    if (ofisyZagruzka) {
      return (
        <p data-ofisy="zagruzka" className="text-xs text-[#687077] leading-relaxed">
          Офисы ещё не получены от держателя: состояние неизвестно.
        </p>
      );
    }
    if (ofisyOtkaz) {
      return (
        <p data-ofisy="otkaz" className="text-xs text-[#20231F] leading-relaxed">
          Офисы прочитать не удалось: {ofisyOtkaz}. Это НЕ значит, что офисов нет —
          значит, канон не прочитан, и показывать здесь нечего.
        </p>
      );
    }
    if (officeList.length === 0) {
      return (
        <p data-ofisy="pusto" className="text-xs text-[#687077] leading-relaxed">
          Офисов у арендатора нет: держатель ответил пустым списком.
        </p>
      );
    }
    return null;
  };

  // Расчёт максимума для динамической шкалы SVG

  // Запуск live аудита.
  // 🔴 РАНЬШЕ ЭТО БЫЛА ИНСЦЕНИРОВКА: таймер накручивал проценты и через две
  //    секунды рапортовал о завершённой проверке 72 сигналов, не обратившись
  //    НИ К ОДНОЙ ручке. Отчёт о работе, которой не было, хуже отсутствия
  //    кнопки: по нему перестают проверять руками.
  // 🔴 Раньше здесь крутился таймер и рапортовал об успехе, ничего не проверив.
  //    Теперь кнопка открывает окно, которое запускает настоящий прогон на
  //    сервере и показывает ЕГО состояние: ни одной величины клиент не считает.
  // 🔴 ЗДЕСЬ НЕ ДОЛЖНО БЫТЬ ВЕТКИ «отдать нажатие наружу». Она тут была, и с
  //    16.09.2026 по 17.09.2026 главная кнопка на бою открывала СТАРОЕ окно
  //    (`AuditRunner`, аудит профиля через GPT-4o): страница передавала
  //    `onRunAudit`, ветка срабатывала первой, и до окна с воротами нажатие не
  //    доходило НИ РАЗУ. Нашли глазами; ни один стенд не покраснел, потому что
  //    каждый судил свой компонент, а «куда ведёт кнопка на собранной
  //    странице» не было утверждением ни об одном из них.
  //    Сторож маршрута: `__tests__/header-audit-button-route.test.js`.
  const handleTriggerAudit = () => {
    setAuditOpen(true);
  };

  const [auditOpen, setAuditOpen] = useState(false);

  // ── Разбор ответа `/latest` ───────────────────────────────────────────────
  const otchet = (otchetOtvet && otchetOtvet.report) ? otchetOtvet.report : null;
  const nap = otchet ? otchet.nap : null;
  const geoItogo = (otchet && otchet.geo && otchet.geo._itogo) ? otchet.geo._itogo : null;
  const predpisaniya = (otchet && Array.isArray(otchet.prescriptions)) ? otchet.prescriptions : null;
  const kritichnyh = predpisaniya ? predpisaniya.filter((p) => p && p.severity === 'critical').length : 0;
  const obychnyh = predpisaniya ? (predpisaniya.length - kritichnyh) : 0;

  // ── Шкалы верхнего ряда: считаются ОДНИМ помощником ──────────────────────
  // 🔴 Индекс NAP считается ОДИН раз и уходит в две карточки (`nap-i-citaty` и
  //    `nap-baseline`). Второй счёт той же величины разошёлся бы с первым молча,
  //    и на экране стояли бы два разных изображения одного числа.
  const shkalaNap = nap ? dolyaDlyaShkaly(nap.overall_score) : null;
  const shkalaCitat = geoItogo
    ? dolyaDlyaShkaly(geoItogo.our_citations_total, geoItogo.citations_total)
    : null;
  const shkalaPokrytiya = nap ? dolyaDlyaShkaly(nap.measured_count, nap.total_count) : null;

  // 🔴 Состояния без замера: тексты РАЗЛИЧАЮТСЯ дословно и не содержат ни
  // одного числа и ни одного процента — включая «0». Ноль на экране означал бы
  // измеренный ноль, а измерения здесь не было.
  const sostoyanieZamera = (() => {
    if (zagruzka) return 'Спрашиваем сервер о последнем замере…';
    if (otkazZaprosa) return `Не смогли спросить сервер: ${otkazZaprosa}. Это НЕ значит, что замера не было.`;
    if (!otchetOtvet) return 'Ответа о последнем замере нет: сервер промолчал.';
    if (otchetOtvet.status === 'NEVER_RUN') return 'Замер не запускался.';
    if (otchetOtvet.status === 'CACHE_UNREADABLE') return 'Последний замер есть, но его запись не читается — это НЕ «замеров не было».';
    if (otchetOtvet.status === 'INVALID_TENANT') return 'Отказ: идентификатор арендатора сервер не принял.';
    if (!otchet) return 'Ответ пришёл без отчёта: показывать нечего.';
    return null;
  })();

  // Кнопка ТОЛЬКО открывает существующее окно аудита: второй точки платного
  // запуска здесь не заводится.
  const nuzhnaKnopkaZamera = Boolean(otkazZaprosa)
    || (!zagruzka && Boolean(otchetOtvet)
        && (otchetOtvet.status === 'NEVER_RUN' || otchetOtvet.status === 'CACHE_UNREADABLE'));

  const handleExecuteFix = () => {
    // 🔴 Раньше эта кнопка сообщала о выкатке схемы в JSON-LD главной страницы
    //    сайта и красилась в зелёное, НИЧЕГО НИКУДА НЕ ВЫКАТИВ.
    toast.error('Автоматической правки здесь нет: ручки, которая меняла бы JSON-LD на сайте, не существует. Прежнее сообщение об успешной выкатке было ложным.');
  };

  return (
    <div className="min-h-screen bg-[#F8F7F2] text-[#20231F] p-4 lg:p-8 font-sans">
      <div className="max-w-7xl mx-auto space-y-6">

        {/* ШАПКА РАЗДЕЛА: Quiet Luxury Editorial */}
        <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 lg:p-8 shadow-xs">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-wider font-semibold text-[#8C7A5B] mb-2">
                <Sparkles className="w-3.5 h-3.5 text-[#C8A653]" />
                <span>GROWTH & REPUTATION ENGINE</span>
                {/* 🔴 Город фирмы был вписан в вёрстку. Название главного офиса
                    приходит от держателя; не прочитан — надписи нет. */}
                {officeList.filter((o) => o.is_main).map((o) => (
                  <React.Fragment key={o.kluch}>
                    <span className="text-[#E5E1D6]">·</span>
                    <span>{o.nazvanie}</span>
                  </React.Fragment>
                ))}
              </div>
              <h1 className="text-2xl lg:text-3xl font-serif text-[#20231F] font-normal tracking-tight">
                {activeTab === 'marketing' && 'Acquisition & conversion pulse'}
                {activeTab === 'reputation' && 'Public trust — источника измерений нет'}
                {activeTab === 'citations' && 'Verified legal citation network'}
                {activeTab === 'locations' && 'Office locations & truth profiles'}
              </h1>
              <p className="text-sm text-[#687077] mt-1.5 max-w-2xl leading-relaxed">
                {activeTab === 'marketing' && 'Demand metrics across Sofia Voice AI, Google Maps, client referrals and website chat.'}
                {activeTab === 'reputation' && 'Сигналы репутации отсюда НЕ измеряются: живого источника у этих карточек нет.'}
                {activeTab === 'citations' && 'Учётные записи, адреса и допуски. Адрес привязки берётся у держателя офисов, а не из вёрстки.'}
                {activeTab === 'locations' && 'Manage office branches, launch 10-Agent Squad battles, configure NAP and API workers.'}
              </p>
            </div>

            {/* БЫСТРЫЕ ДЕЙСТВИЯ: Agent Battle, Source of Truth, Analytics */}
            <div className="flex flex-wrap items-center gap-2.5">
              {/* 🔴 Кнопки, которым нужен профиль, ВЫКЛЮЧЕНЫ, когда профиля нет:
                   раньше в этом случае открывалось окно с ВЫДУМАННЫМ профилем. */}
              <button
                onClick={() => mainProfile && onOpenAgentBattle && onOpenAgentBattle(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-4 inline-flex items-center gap-2 bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'hover:bg-[#F3E7C9] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                title={mainProfile ? 'Open 10 AI Agent Battle Arena' : netProfilya}
              >
                <Swords className="w-4 h-4 text-[#C8A653]" />
                <span>Agent Battle Arena</span>
              </button>

              <button
                onClick={() => mainProfile && onOpenSourceOfTruth && onOpenSourceOfTruth(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-4 inline-flex items-center gap-2 bg-[#F8F7F2] text-[#20231F] border border-[#E5E1D6] text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'hover:bg-[#EFECE3] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                title={mainProfile ? 'Источник правды главного профиля' : netProfilya}
              >
                <FileText className="w-4 h-4 text-[#687077]" />
                <span>Source of Truth</span>
              </button>

              <button
                onClick={() => mainProfile && onOpenAnalytics && onOpenAnalytics(mainProfile)}
                disabled={!mainProfile}
                className={`h-10 px-3.5 inline-flex items-center gap-2 bg-white text-[#20231F] border border-[#E5E1D6] text-xs font-semibold rounded-xl transition-colors shadow-2xs ${mainProfile ? 'hover:bg-[#F8F7F2] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                title={mainProfile ? 'Open Analytics Command' : netProfilya}
              >
                <BarChart3 className="w-4 h-4 text-[#687077]" />
                <span>Analytics</span>
              </button>

              <button
                onClick={handleTriggerAudit}
                disabled={false}
                className="h-10 px-4 inline-flex items-center gap-2 bg-[#20231F] hover:bg-[#343833] text-white text-xs font-semibold rounded-xl transition-all shadow-xs cursor-pointer"
              >
                {/* 🔴 Полоска «Auditing (65%)» крутилась от таймера, а не от
                    хода работы: прибор, не связанный с тем, что он показывает. */}
                <ShieldCheck className="w-4 h-4 text-[#C8A653]" />
                <span>Run Full Audit</span>
              </button>
            </div>
          </div>

          {/* НАВИГАЦИОННЫЕ ТАБЫ РАЗДЕЛА */}
          <div className="flex items-center gap-2 mt-8 pt-6 border-t border-[#F1EEE4] overflow-x-auto">
            <button
              onClick={() => setActiveTab('reputation')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'reputation'
                  ? 'bg-[#20231F] text-white'
                  : 'text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4]'
              }`}
            >
              Reputation & Trust
            </button>
            <button
              onClick={() => setActiveTab('marketing')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'marketing'
                  ? 'bg-[#20231F] text-white'
                  : 'text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4]'
              }`}
            >
              Marketing Pulse
            </button>
            <button
              onClick={() => setActiveTab('locations')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'locations'
                  ? 'bg-[#20231F] text-white'
                  : 'text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4]'
              }`}
            >
              {/* 🔴 Здесь стоял запасной ЛИТЕРАЛ «2»: счётчик рапортовал о том,
                   чего не считал, ровно тогда, когда ручка профилей отдавала 500.
                   `profiles` приходит ПРОПОМ с умолчанием `[]`, и пустой массив
                   неотличим от «не передали» — поэтому пусто печатается
                   ПРОЧЕРКОМ, а не нулём: нуля здесь никто не измерял. */}
              Office Profiles ({profiles.length > 0 ? profiles.length : NET_CHISLA})
            </button>
            <button
              onClick={() => setActiveTab('citations')}
              className={`px-4 py-2 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'citations'
                  ? 'bg-[#20231F] text-white'
                  : 'text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4]'
              }`}
            >
              Citations & Directories
            </button>
          </div>
        </div>

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 1: REPUTATION & PUBLIC TRUST           */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'reputation' && (
          <div className="space-y-6">
            {/* КАРТОЧКИ ВЕРХНЕГО РЯДА: четыре величины ИЗ ОТЧЁТА `/full-audit/latest`.
                🔴 Сводного «скора репутации» здесь НЕТ и быть не может: отчёт не
                содержит его НАРОЧНО (`full_audit_orchestrator.py:548-552`), а сложить
                его на клиенте значило бы назначить веса, которых никто не назначал.
                Каждая величина показана СО СВОИМ знаменателем. */}

            {/* 🔴 ПОДПИСЬ «ЧЕМ И КОГДА МЕРЕНО» — ОДНА, И СТОИТ ДО ЧИСЕЛ.
                Раньше этот блок был в подвале КАЖДОЙ из четырёх карточек и
                читался как отладочный журнал. Подпись не убрана, а СВЕДЕНА в
                одно место: без неё число молча читается как сегодняшнее.
                Плашка рисуется по тому же условию, что и прежний подвал
                (`otchet`), и стоит ВНЕ узлов `[data-card]` — состояния без
                замера по-прежнему говорят сами карточки, каждое своим текстом. */}
            {otchet && <PodpisZameraEdinaya otvet={otchetOtvet} nap={nap} />}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

              {/* 1. NAP и цитаты нейросетей — РАЗДЕЛЬНО, две величины, два знаменателя. */}
              <div data-card="nap-i-citaty" className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#687077]">NAP и цитаты нейросетей</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (
                    <div className="mt-2 space-y-1">
                      {!nap ? (
                        <div className="text-xs text-[#687077] leading-relaxed">NAP в отчёте нет</div>
                      ) : nap.error === 'canon_not_available' ? (
                        <div className="text-xs text-[#687077] leading-relaxed">
                          канон недоступен — замер NAP не проводился; ни процента, ни знаменателя здесь не показывается
                        </div>
                      ) : (
                        <>
                          {/* 🔴 Печатается `chislo` — то, что пришло с сервера.
                              Под шкалу подгоняется ТОЛЬКО ширина полосы ниже. */}
                          <div className="text-3xl font-serif text-[#20231F] leading-none pb-1">
                            NAP: {shkalaNap && shkalaNap.vid === 'est' ? `${shkalaNap.chislo} %` : NET_CHISLA}
                          </div>
                          <Polosa itog={shkalaNap} imya="nap" />
                          <div className="text-xs text-[#687077] pt-0.5">измерено {nap.measured_count} из {nap.total_count}</div>
                          <div className="text-[10px] text-[#687077] leading-relaxed">взвешенный индекс (веса каталогов), не среднее</div>
                        </>
                      )}
                      {geoItogo ? (
                        <div className="pt-2 border-t border-[#F8F7F2] space-y-1">
                          <div className="text-xs text-[#20231F]">
                            цитаты нейросетей: {(geoItogo.our_citations_total === null || geoItogo.our_citations_total === undefined) ? NET_CHISLA : geoItogo.our_citations_total} из {geoItogo.citations_total}
                          </div>
                          <Polosa itog={shkalaCitat} imya="citaty" />
                        </div>
                      ) : (
                        <div className="text-xs text-[#687077] pt-2 border-t border-[#F8F7F2] leading-relaxed">нейросети не опрашивались</div>
                      )}
                      {geoItogo && (geoItogo.our_citations_total === null || geoItogo.our_citations_total === undefined) && (
                        <div className="text-[10px] text-[#687077] leading-relaxed">домен фирмы не прочитался — сравнивать не с чем</div>
                      )}
                      {otchet && otchet.geo_mode === 'express' && (
                        <div className="text-[10px] text-amber-800 leading-relaxed">
                          экспресс-прогон: один повтор на подсказку вместо трёх — точность ниже
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {nuzhnaKnopkaZamera && (
                  <button
                    onClick={() => setAuditOpen(true)}
                    className="mt-3 h-9 px-3 inline-flex items-center justify-center gap-2 bg-[#F8F7F2] hover:bg-[#EFECE3] text-[#20231F] border border-[#E5E1D6] text-[11px] font-semibold rounded-xl transition-colors cursor-pointer"
                  >
                    Запустить замер в окне аудита
                  </button>
                )}
              </div>

              {/* 2. Open Issues: длина `prescriptions`, разбивка СЧИТАЕТСЯ из массива. */}
              <div data-card="open-issues" className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#687077]">Open Issues</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : predpisaniya ? (
                    <div className="mt-2 space-y-1">
                      <div className="text-2xl font-serif text-[#20231F] leading-tight">Предписаний в отчёте: {predpisaniya.length}</div>
                      {/* 🔴 ТЕКСТОВАЯ ФОРМА «критичных: N» СОХРАНЕНА НАРОЧНО.
                          Её стережёт зонд 7 (`/критичных:\s*3/`), который стоит
                          не для красоты: он доказывает, что разбивка СЧИТАЕТСЯ
                          из массива `prescriptions`, а не написана в вёрстке.
                          Смена словоформы ради косметики ослабила бы работающую
                          проверку; поэтому изменён ВИД бейджа, а не слова. */}
                      <div className="flex flex-wrap items-center gap-1.5 pt-1">
                        <span className="inline-flex items-center px-2 py-0.5 rounded-lg bg-[#F6E7DC] text-[#A35B2A] border border-[#E8CDBA] text-[11px] font-semibold">
                          критичных: {kritichnyh}
                        </span>
                        <span className="inline-flex items-center px-2 py-0.5 rounded-lg bg-[#F8F7F2] text-[#687077] border border-[#E5E1D6] text-[11px] font-semibold">
                          обычных: {obychnyh}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">предписаний в отчёте нет</div>
                  )}
                </div>
              </div>

              {/* 3. Public Entity Status: утверждение о том, ЧТО ИЗМЕРЕНО.
                  🔴 «Fully Verified» и любые синонимы проверенности убраны: это было
                  утверждением о проверенности без единой проверки. */}
              <div data-card="entity-status" className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#687077]">Public Entity Status</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (!nap || !nap.canon) ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">канон недоступен</div>
                  ) : (
                    <div className="mt-2 space-y-1">
                      <div className="text-sm text-[#20231F]">
                        канонических локаций: {Array.isArray(nap.canon.locations) ? nap.canon.locations.length : NET_CHISLA}
                      </div>
                      <div className="text-sm text-[#20231F] pt-1">каталогов измерено: {nap.measured_count} из {nap.total_count}</div>
                      <Polosa itog={shkalaPokrytiya} imya="pokrytie" />
                      <div className="text-[10px] text-[#687077] leading-relaxed pt-0.5">
                        это утверждение о том, ЧТО измерено, а не оценка проверенности
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 4. NAP Baseline (бывшая «30D Health Trend»).
                  🔴 Одна точка — НЕ тренд: ни кривой, ни искры, ни стрелки. */}
              <div data-card="nap-baseline" className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs flex flex-col justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#687077]">NAP Baseline</div>
                  {sostoyanieZamera ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">{sostoyanieZamera}</div>
                  ) : (!nap || nap.overall_score === null || nap.overall_score === undefined) ? (
                    <div className="text-xs text-[#687077] mt-2 leading-relaxed">индекса NAP в отчёте нет: {NET_CHISLA}</div>
                  ) : (
                    <div className="mt-2 space-y-2">
                      <div className="flex items-baseline gap-2 flex-wrap">
                        <span className="text-3xl font-serif text-[#20231F] leading-none">
                          {shkalaNap && shkalaNap.vid === 'est' ? `${shkalaNap.chislo} %` : NET_CHISLA}
                        </span>
                        <span className="inline-flex items-center px-2 py-0.5 rounded-lg bg-[#F8F7F2] text-[#687077] border border-[#E5E1D6] text-[10px] font-semibold uppercase tracking-wider">
                          базовая линия
                        </span>
                      </div>
                      {/* 🔴 ОДНА ТОЧКА НА ПУСТОМ ТРЕКЕ, И ТОЧКА СТОИТ ПО ОСИ
                          ВЕЛИЧИНЫ (0..100), а не по оси времени: одна точка во
                          времени — не тренд, и её горизонтальное положение на
                          временной оси было бы назначено от балды. Ни линии, ни
                          второй точки, ни стрелки здесь нет и быть не может. */}
                      {shkalaNap && shkalaNap.vid === 'est' && (
                        <div className="relative h-3 flex items-center">
                          <div className="absolute inset-x-0 h-1.5 bg-[#F1EEE4] rounded-full" />
                          <div
                            data-shkala="baseline"
                            data-vne-shkaly={shkalaNap.vneShkaly || undefined}
                            data-nol-izmeren={shkalaNap.nolIzmeren ? '1' : undefined}
                            style={{ width: `${shkalaNap.shirina}%` }}
                            className="relative h-1.5"
                          >
                            <span className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-2.5 h-2.5 rounded-full border-2 border-white shadow-xs ${shkalaNap.vneShkaly ? 'bg-[#A35B2A]' : 'bg-[#C8A653]'}`} />
                          </div>
                        </div>
                      )}
                      <div className="text-[10px] text-[#687077] leading-relaxed">
                        точка старта зафиксирована {nap.measured_at || 'момент замера не назван'};
                        график динамики строится от трёх последовательных замеров
                      </div>
                      <div className="text-[10px] text-[#687077] leading-relaxed">
                        это взвешенный индекс NAP, а не «здоровье»; одна точка — не тренд
                      </div>
                    </div>
                  )}
                </div>
              </div>

            </div>

            {/* БЛОК УПРАВЛЕНИЯ ОФИСАМИ И АРЕНАМИ: офисы канона держателя */}
            <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-5 border-b border-[#F1EEE4]">
                <div>
                  <div className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-[#8C7A5B]">
                    <Building className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>Office Truth & 10 AI Battle Squad</span>
                  </div>
                  <h3 className="text-lg font-serif text-[#20231F] mt-0.5">Active Office Profiles & Truth Anchors</h3>
                  <p className="text-xs text-[#687077] mt-0.5">Launch agent battles, edit NAP credentials and inspect AI visibility per location.</p>
                </div>
              </div>

              <div className="mt-4">
                <SostoyanieOfisov />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
                {officeList.map((office) => (
                  <div
                    key={office.kluch}
                    className={`p-5 rounded-xl flex flex-col justify-between space-y-4 ${
                      office.is_main
                        ? 'border-2 border-[#C8A653] bg-[#FCFBF8]'
                        : 'border border-[#E5E1D6] bg-white'
                    }`}
                  >
                    <div>
                      <div className="flex items-center justify-between gap-2">
                        <span className="text-sm font-bold text-[#20231F]">{office.nazvanie}</span>
                        <div className="flex items-center gap-1.5">
                          {gmbAuthStatus.has_gmb_scope && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded bg-[#E6F6EE] text-[#0B8B5E] border border-[#B7E5D0]">
                              <CheckCircle2 className="w-3 h-3" />
                              <span>Google Live</span>
                            </span>
                          )}
                          <span
                            className={`text-[10px] font-bold px-2 py-0.5 rounded ${
                              office.is_main
                                ? 'bg-[#FAF4E5] text-[#A97F2E]'
                                : 'bg-[#F1EEE4] text-[#687077]'
                            }`}
                          >
                            {office.badge}
                          </span>
                        </div>
                      </div>
                      <div className="text-xs text-[#687077] mt-1.5 flex items-start gap-1.5">
                        <MapPin className={`w-3.5 h-3.5 shrink-0 mt-0.5 ${office.is_main ? 'text-[#C8A653]' : 'text-[#687077]'}`} />
                        <span className="leading-snug">{office.address}</span>
                      </div>
                      {/* 🔴 Имени адвоката здесь больше нет: в каноне офисов его
                          нет, а вписать его в вёрстку значит завести копию. */}
                      <div className="text-xs text-[#20231F] font-medium mt-1.5">
                        {office.company_name} · {office.phone}
                      </div>
                      {!office.profileId && (
                        <div className="text-[10px] text-[#687077] mt-1">
                          Профиль не привязан: перехода в пульт GMB нет.
                        </div>
                      )}
                      {/* 🔴 Здесь стояли «5.0 ★ (14 reviews)» и «98.5% Accuracy»
                          — оценка Google и точность NAP, НАПИСАННЫЕ руками. */}
                      <div className="mt-2 flex items-center justify-between text-xs pt-2 border-t border-[#F1EEE4]">
                        <span className="text-[10px] text-[#687077] leading-relaxed">
                          Отзывы и точность NAP отсюда не измеряются: источника нет.
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 pt-3 border-t border-[#E5E1D6]">
                      {/* 🔴 Идентификатор профиля берётся ТОЛЬКО из `profiles`:
                           нет совпадения — переход недоступен, а не открывает
                           пульт с выдуманным профилем. */}
                      <button
                        onClick={() => {
                          if (!office.profileId) return;
                          setSelectedGmbOffice({ ...office, id: office.profileId });
                          setIsGmbModalOpen(true);
                        }}
                        disabled={!office.profileId}
                        className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg transition-colors shadow-2xs ${
                          !office.profileId
                            ? 'bg-[#F1EEE4] text-[#687077] border border-[#E5E1D6] opacity-60 cursor-not-allowed'
                            : gmbAuthStatus.has_gmb_scope
                              ? 'bg-[#E6F6EE] text-[#0B8B5E] border border-[#B7E5D0] hover:bg-[#D4EFE3] cursor-pointer'
                              : 'bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] cursor-pointer'
                        }`}
                        title={office.profileId ? 'Open GMB AI Command Center' : 'Профиль не привязан'}
                      >
                        <Sparkles className="w-3 h-3 text-[#C8A653]" />
                        <span>GMB AI</span>
                        {gmbAuthStatus.has_gmb_scope && (
                          <span className="w-1.5 h-1.5 rounded-full bg-[#0B8B5E] inline-block ml-0.5" />
                        )}
                      </button>
                      {office.gmb_url && (
                        <a
                          href={office.gmb_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F8F7F2] transition-colors cursor-pointer shadow-2xs"
                          title="Open Google Maps Listing"
                        >
                          <ExternalLink className="w-3 h-3 text-[#C8A653]" />
                          <span>GMB</span>
                        </a>
                      )}
                      <button
                        onClick={() => office.profileId && onOpenSourceOfTruth && onOpenSourceOfTruth({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-white border border-[#E5E1D6] text-[#20231F] transition-colors shadow-2xs ${office.profileId ? 'hover:bg-[#F8F7F2] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        title={office.profileId ? 'Источник правды офиса' : 'Профиль не привязан'}
                      >
                        <FileText className="w-3 h-3 text-[#687077]" />
                        <span>Truth</span>
                      </button>
                      <button
                        onClick={() => office.profileId && onOpenAgentBattle && onOpenAgentBattle({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        title={office.profileId ? 'Арена' : 'Профиль не привязан'}
                        className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg transition-colors shadow-2xs ${!office.profileId ? 'opacity-50 cursor-not-allowed ' : 'cursor-pointer '}${
                          office.is_main
                            ? 'bg-[#20231F] text-white hover:bg-[#343833]'
                            : 'bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9]'
                        }`}
                      >
                        <Swords className="w-3 h-3 text-[#C8A653]" />
                        <span>Arena</span>
                      </button>
                      <button
                        onClick={() => office.profileId && onOpenAnalytics && onOpenAnalytics({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        className={`h-8 px-2.5 inline-flex items-center gap-1 text-xs font-semibold rounded-lg bg-white border border-[#E5E1D6] text-[#20231F] transition-colors shadow-2xs ${office.profileId ? 'hover:bg-[#F8F7F2] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        title={office.profileId ? 'Analytics' : 'Профиль не привязан'}
                      >
                        <BarChart3 className="w-3 h-3 text-[#687077]" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ОСНОВНОЙ БЛОК: Слева Стратегический план, справа Распределение и проверки */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

              {/* СЛЕВА: Стратегический план действий и Сеть цитирования (2 колонки) */}
              <div className="lg:col-span-2 space-y-6">

                {/* Priority Action Card */}
                <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                  <div className="flex items-center justify-between pb-4 border-b border-[#F1EEE4]">
                    <div className="flex items-center gap-2">
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] uppercase tracking-wider font-bold bg-[#FAF4E5] text-[#A97F2E]">
                        Strategic Action Plan
                      </span>
                      <span className="text-xs text-[#687077]">Priority Recommendation</span>
                    </div>
                    <span className="text-xs font-semibold text-[#687077] bg-[#F1EEE4] px-2.5 py-1 rounded-md">
                      Влияние не оценивалось
                    </span>
                  </div>

                  <div className="mt-5 space-y-3">
                    <h3 className="text-lg font-serif text-[#20231F]">
                      Verify attorney-service entity links on the homepage
                    </h3>
                    <p className="text-xs text-[#687077] leading-relaxed">
                      Attorney profile URLs on fitenkolaw.com should have bidirectional <code className="px-1.5 py-0.5 bg-[#F8F7F2] rounded text-[#20231F] font-mono">sameAs</code> and <code className="px-1.5 py-0.5 bg-[#F8F7F2] rounded text-[#20231F] font-mono">memberOf</code> links in the LegalService schema to establish full entity authority with Gemini, Perplexity and Google Search.
                    </p>

                    <div className="p-4 bg-[#F8F7F2] border border-[#E5E1D6] rounded-xl text-xs space-y-2">
                      <div className="flex items-center justify-between text-[#687077]">
                        <span>Target Entity:</span>
                        <strong className="text-[#20231F]">schema.org/LegalService · главный офис</strong>
                      </div>
                      <div className="flex items-center justify-between text-[#687077]">
                        <span>Anchor Address:</span>
                        {/* 🔴 Адрес привязки был ЧЕТВЁРТОЙ копией канона в вёрстке.
                            Теперь он приходит от держателя; не прочитан — прочерк. */}
                        <span className="text-[#20231F]">
                          {(officeList.find((o) => o.is_main) || {}).address || NET_CHISLA}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-[#687077]">
                        <span>Verification Status:</span>
                        <span className="text-[#687077] font-semibold">не проверялось</span>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 pt-3">
                      <button
                        onClick={handleExecuteFix}
                        className="h-9 px-4 rounded-xl text-xs font-semibold inline-flex items-center gap-2 transition-colors cursor-pointer bg-[#20231F] hover:bg-[#343833] text-white"
                      >
                        <CheckCircle2 className="w-3.5 h-3.5" />
                        <span>Execute Automated Fix</span>
                      </button>

                      <button
                        onClick={() => {
                          // Проверки схемы здесь не происходит — сказать об
                          // этом честнее, чем напечатать «verified».
                          toast('JSON-LD отсюда не проверяется: ручки разбора схемы у этого экрана нет.', {
                            icon: 'ℹ️'
                          });
                        }}
                        className="h-9 px-4 rounded-xl text-xs font-semibold bg-white border border-[#E5E1D6] hover:bg-[#F8F7F2] text-[#20231F] transition-colors cursor-pointer"
                      >
                        Inspect Schema JSON-LD
                      </button>
                    </div>
                  </div>
                </div>

                {/* Directory Presence Cards */}
                <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                  <div className="flex items-center justify-between mb-5">
                    <div>
                      <h3 className="text-base font-serif text-[#20231F]">Active Directory Authority</h3>
                      <p className="text-xs text-[#687077] mt-0.5">Записи справочников строятся из канона держателя офисов — по одной на офис, и ни одной сверх</p>
                    </div>
                    {/* 🔴 «6 of 6 Verified» держалось на длине зашитого списка,
                        а не на проверке хотя бы одной записи. */}
                    <span className="text-[11px] font-semibold text-[#687077] bg-[#F1EEE4] px-2.5 py-1 rounded-md">
                      проверка не проводится
                    </span>
                  </div>

                  <SostoyanieOfisov />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                    {officeList.map((o) => (
                      <div
                        key={o.kluch}
                        className="p-4 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] space-y-2.5 block"
                      >
                        <div className="flex items-start justify-between">
                          <div>
                            <div className="text-xs font-semibold text-[#20231F]">
                              Google Business Profile · {o.nazvanie}
                            </div>
                            <div className="text-[11px] text-[#687077] mt-0.5">{o.address}</div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between text-xs pt-2 border-t border-[#F1EEE4]">
                          {/* 🔴 Ссылки на запись в Google здесь НЕТ НАРОЧНО: в каноне
                              её нет, а написанная от руки ссылка — утверждение о мире. */}
                          <span className="text-[10px] text-[#687077]">
                            состояние записи не проверялось; подтверждённой ссылки на запись в каноне нет
                          </span>
                          <span className="text-[10px] text-[#8C7A5B] font-medium">{o.badge}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>

              {/* СПРАВА: Распределение категорий и Журнал верификаций (1 колонка) */}
              <div className="space-y-6">

                {/* Issue Distribution Card */}
                <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                  <h3 className="text-base font-serif text-[#20231F]">Signal Distribution</h3>
                  {/* 🔴 УБРАНЫ ЧЕТЫРЕ КАТЕГОРИИ С ЧИСЛАМИ И ДОЛЯМИ (42 / 58,3 %,
                      18 / 25,0 %, 11 / 15,3 %, 1 / 1,4 %) и полоса, ширина
                      которой рисовалась ИЗ ТЕХ ЖЕ литералов. Подпись «72
                      verified signals» — их сумма, то есть тоже литерал. */}
                  <p className="text-xs text-[#687077] mt-0.5 mb-5 leading-relaxed">{ISTOCHNIKA_NET}</p>
                </div>

                {/* Recent Automated Audits.
                    🔴 Здесь стоял ЖУРНАЛ ПРОВЕРОК, которых не было: три записи
                    с зелёными галочками и относительным временем «12m ago»,
                    «2h ago», «1d ago». Относительный срок лжёт уже в момент
                    чтения ([[knowledge_relative_deadline_outlives_itself]]), а
                    здесь он ещё и отсчитывался от НИЧЕГО: записи зашиты в файл
                    и показывали одно и то же в любой день. */}
                <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                  <h3 className="text-base font-serif text-[#20231F]">Audit Activity</h3>
                  <p className="text-xs text-[#687077] mt-0.5 mb-4 leading-relaxed">
                    {ISTOCHNIKA_NET} Журнала проверок у этого экрана нет — прежние
                    три записи с отметками «12m ago» были зашиты в файл.
                  </p>
                </div>

              </div>

            </div>
          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 2: MARKETING PULSE                      */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'marketing' && (
          <div className="space-y-6">

            {/* ГЛАВНЫЙ ГРАФИК СПРОСА И КОНВЕРСИЙ */}
            <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 lg:p-8 shadow-xs">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 pb-6 border-b border-[#F1EEE4]">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-[#8C7A5B]">Acquisition & Conversion</div>
                  <h2 className="text-xl font-serif text-[#20231F] mt-0.5">Demand and conversion trend</h2>
                  <p className="text-xs text-[#687077] mt-0.5">Tracking high-intent calls, bookings, and organic lead acquisition.</p>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  {/* Переключатель 30d / 90d */}
                  <div className="inline-flex bg-[#F8F7F2] p-1 rounded-xl border border-[#E5E1D6]">
                    <button
                      onClick={() => setTimeframe('30d')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        timeframe === '30d' ? 'bg-white text-[#20231F] shadow-2xs' : 'text-[#687077] hover:text-[#20231F]'
                      }`}
                    >
                      30 days
                    </button>
                    <button
                      onClick={() => setTimeframe('90d')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        timeframe === '90d' ? 'bg-white text-[#20231F] shadow-2xs' : 'text-[#687077] hover:text-[#20231F]'
                      }`}
                    >
                      90 days
                    </button>
                  </div>

                  {/* Переключатель фокуса метрики */}
                  <div className="inline-flex bg-[#F8F7F2] p-1 rounded-xl border border-[#E5E1D6]">
                    <button
                      onClick={() => setMetricType('leads')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'leads' ? 'bg-[#20231F] text-white' : 'text-[#687077] hover:text-[#20231F]'
                      }`}
                    >
                      Leads
                    </button>
                    <button
                      onClick={() => setMetricType('booked')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'booked' ? 'bg-[#0B8B5E] text-white' : 'text-[#687077] hover:text-[#20231F]'
                      }`}
                    >
                      Booked calls
                    </button>
                    <button
                      onClick={() => setMetricType('organic')}
                      className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors cursor-pointer ${
                        metricType === 'organic' ? 'bg-[#8C7A5B] text-white' : 'text-[#687077] hover:text-[#20231F]'
                      }`}
                    >
                      Organic reach
                    </button>
                  </div>
                </div>
              </div>

              {/* Легенда */}
              <div className="flex items-center gap-6 mt-6 mb-4 text-xs font-semibold">
                <div className="flex items-center gap-2 text-[#20231F]">
                  <span className="w-3 h-3 rounded-full bg-[#C8A653]" />
                  <span>Total Inquiries (Leads)</span>
                </div>
                <div className="flex items-center gap-2 text-[#0B8B5E]">
                  <span className="w-3 h-3 rounded-full bg-[#0B8B5E]" />
                  <span>Booked Consultations</span>
                </div>
                <div className="flex items-center gap-2 text-[#8C7A5B]">
                  <span className="w-3 h-3 rounded-full bg-[#8C7A5B]" />
                  <span>Organic Search Reach</span>
                </div>
              </div>

              {/* 🔴 ГРАФИК УБРАН. Он рисовался из двух зашитых наборов точек
                  (30 и 90 дней) и читался как замер спроса: у кривой нет
                  пометки «нарисовано», её смотрят глазами и верят форме. */}
              <div className="w-full mt-4 p-8 rounded-xl border border-dashed border-[#E5E1D6] bg-[#F8F7F2] text-center">
                <div className="text-xs text-[#687077] leading-relaxed max-w-lg mx-auto">
                  {ISTOCHNIKA_NET} Кривые спроса за {timeframe === '30d' ? '30' : '90'} дней
                  и разрез по «{metricType}» здесь не строятся: сюда не подключён
                  ни один живой счётчик обращений.
                </div>
              </div>

              {/* Метрики сводки. 🔴 Здесь стояли 138 / 62 / 44,9 % / $21 700 и
                  приросты «+18,4 % к прошлому месяцу» — ни одно число не
                  считалось, а последнее ещё и обещало деньги. */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-[#F1EEE4]">
                {['Total Inquiries', 'Booked Consults', 'Avg Conversion', 'Revenue Pipeline'].map((podpis) => (
                  <div key={podpis}>
                    <div className="text-[11px] text-[#687077] uppercase tracking-wider font-semibold">{podpis}</div>
                    <div className="text-2xl font-serif text-[#20231F] mt-0.5">{NET_CHISLA}</div>
                    <div className="text-xs text-[#687077] font-medium mt-0.5">источника нет</div>
                  </div>
                ))}
              </div>
            </div>

            {/* 4 КАРТОЧКИ КАНАЛОВ ПРИВЛЕЧЕНИЯ.
                🔴 Числа и «insight» убраны: конверсия 47,2 % с полоской
                прогресса выглядела замером, а была литералом. Названия каналов
                остались — они настоящие, неизвестна только их отдача. */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {KANALY.map(channel => {
                const Icon = channel.icon;
                return (
                  <div key={channel.id} className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <div className="w-8 h-8 rounded-xl bg-[#F8F7F2] border border-[#E5E1D6] flex items-center justify-center text-[#20231F]">
                          <Icon className="w-4 h-4" />
                        </div>
                      </div>

                      <h3 className="text-sm font-semibold text-[#20231F]">{channel.name}</h3>

                      <div className="mt-3 flex items-baseline justify-between">
                        <span className="text-2xl font-serif font-normal text-[#20231F]">{NET_CHISLA}</span>
                        <span className="text-xs text-[#687077]">конверсия не измеряется</span>
                      </div>
                    </div>

                    <p className="text-[11px] text-[#687077] leading-relaxed pt-3 border-t border-[#F8F7F2]">
                      {ISTOCHNIKA_NET}
                    </p>
                  </div>
                );
              })}
            </div>

          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 3: OFFICE PROFILES & TRUTH ANCHORS                                */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'locations' && (
          <div className="space-y-6">
            <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 lg:p-8 shadow-xs">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-6 border-b border-[#F1EEE4]">
                <div>
                  <h2 className="text-xl font-serif text-[#20231F]">Practice Locations & Truth Anchors</h2>
                  <p className="text-xs text-[#687077] mt-1 leading-relaxed">
                    Source of Truth data, attorney bios, verified addresses, and 10-Agent Squad battle assignments.
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() => mainProfile && onOpenSourceOfTruth && onOpenSourceOfTruth(mainProfile)}
                    disabled={!mainProfile}
                    className={`h-9 px-4 inline-flex items-center gap-2 bg-[#20231F] text-white text-xs font-semibold rounded-xl transition-colors shadow-xs ${mainProfile ? 'hover:bg-[#343833] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                    title={mainProfile ? 'Источник правды главного профиля' : netProfilya}
                  >
                    <FileText className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>Источник правды главного профиля</span>
                  </button>
                </div>
              </div>

              <div className="mt-6">
                <SostoyanieOfisov />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                {officeList.map((office) => (
                  <div
                    key={office.kluch}
                    className={`p-6 rounded-2xl flex flex-col justify-between space-y-4 ${
                      office.is_main
                        ? 'border-2 border-[#C8A653] bg-[#FCFBF8]'
                        : 'border border-[#E5E1D6] bg-white'
                    }`}
                  >
                    <div>
                      <div className="flex items-start justify-between">
                        <div>
                          <div className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[10px] font-bold mb-2 ${
                            office.is_main
                              ? 'bg-[#FAF4E5] text-[#A97F2E]'
                              : 'bg-[#F1EEE4] text-[#687077]'
                          }`}>
                            {office.is_main && <Sparkles className="w-3 h-3 text-[#C8A653]" />}
                            <span>{office.badge.toUpperCase()}</span>
                          </div>
                          <h3 className="text-lg font-serif text-[#20231F]">{office.nazvanie}</h3>
                          <div className="text-xs text-[#687077] mt-1.5 flex items-start gap-1.5">
                            <MapPin className={`w-4 h-4 shrink-0 mt-0.5 ${office.is_main ? 'text-[#C8A653]' : 'text-[#687077]'}`} />
                            <span className="font-medium text-[#20231F]">{office.address}</span>
                          </div>
                          <div className="text-xs text-[#20231F] font-medium mt-1.5">
                            {office.company_name} · {office.phone}
                          </div>
                          {/* 🔴 Описания филиалов были написаны ПО ИМЕНИ ГОРОДА в
                              вёрстке, включая описание несуществующего офиса. Что
                              за офис и как он работает — канон держателя, а не
                              разветвление по строке. */}
                          <p className="text-xs text-[#687077] mt-2 leading-relaxed">
                            {office.is_main
                              ? 'Главный офис канона.'
                              : 'Филиал канона.'}
                            {' '}Режим приёма и часы в этом экране не показываются: их держит канон офисов, и второй копии здесь не заводится.
                          </p>
                          {!office.profileId && (
                            <p className="text-[10px] text-[#687077] mt-1">
                              Профиль не привязан: перехода в пульт GMB, арену и аналитику нет.
                            </p>
                          )}
                        </div>
                      </div>

                      {/* 🔴 Три «показателя» офиса — Squad, Accuracy и Status
                          «Verified» — были литералами: ни состав роя, ни
                          точность NAP, ни проверенность записи отсюда не
                          измеряются. */}
                      <div className="grid grid-cols-3 gap-2 pt-3 mt-3 border-t border-[#E5E1D6] text-center">
                        {['Squad', 'Accuracy', 'Status'].map((podpis) => (
                          <div key={podpis} className="p-2 bg-white rounded-lg border border-[#E5E1D6]">
                            <div className="text-[10px] text-[#687077] uppercase font-bold">{podpis}</div>
                            <div className="text-sm font-bold text-[#687077] mt-0.5">{NET_CHISLA}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 pt-3 border-t border-[#F1EEE4]">
                      <button
                        onClick={() => {
                          if (!office.profileId) return;
                          setSelectedGmbOffice({ ...office, id: office.profileId });
                          setIsGmbModalOpen(true);
                        }}
                        disabled={!office.profileId}
                        className={`h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] transition-colors shadow-2xs ${office.profileId ? 'hover:bg-[#F3E7C9] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        title={office.profileId ? 'Open GMB AI Command Center' : 'Профиль не привязан'}
                      >
                        <Sparkles className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>GMB AI</span>
                      </button>
                      {office.gmb_url && (
                        <a
                          href={office.gmb_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="h-9 px-3 inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-xl bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F8F7F2] transition-colors cursor-pointer shadow-2xs"
                          title="Open Google Maps Listing"
                        >
                          <ExternalLink className="w-3.5 h-3.5 text-[#C8A653]" />
                          <span>GMB</span>
                        </a>
                      )}
                      <button
                        onClick={() => office.profileId && onOpenSourceOfTruth && onOpenSourceOfTruth({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        title={office.profileId ? 'Источник правды офиса' : 'Профиль не привязан'}
                        className={`flex-1 h-9 inline-flex items-center justify-center gap-2 text-xs font-semibold rounded-xl bg-white border border-[#E5E1D6] text-[#20231F] transition-colors shadow-2xs ${office.profileId ? 'hover:bg-[#F8F7F2] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                      >
                        <FileText className="w-3.5 h-3.5 text-[#687077]" />
                        <span>Source of Truth</span>
                      </button>
                      <button
                        onClick={() => office.profileId && onOpenAgentBattle && onOpenAgentBattle({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        title={office.profileId ? 'Арена' : 'Профиль не привязан'}
                        className={`flex-1 h-9 inline-flex items-center justify-center gap-2 text-xs font-semibold rounded-xl transition-colors shadow-xs ${!office.profileId ? 'opacity-50 cursor-not-allowed ' : 'cursor-pointer '}${
                          office.is_main
                            ? 'bg-[#20231F] text-white hover:bg-[#343833]'
                            : 'bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9]'
                        }`}
                      >
                        <Swords className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>Arena</span>
                      </button>
                      <button
                        onClick={() => office.profileId && onOpenAnalytics && onOpenAnalytics({ ...office, id: office.profileId })}
                        disabled={!office.profileId}
                        className={`h-9 px-3 inline-flex items-center justify-center text-xs font-semibold rounded-xl bg-white border border-[#E5E1D6] text-[#20231F] transition-colors shadow-2xs ${office.profileId ? 'hover:bg-[#F8F7F2] cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        title={office.profileId ? 'Analytics Command' : 'Профиль не привязан'}
                      >
                        <BarChart3 className="w-4 h-4 text-[#687077]" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ═════════════════════════════════════════════════════════════════════ */}
        {/* ТАБ 4: CITATIONS & DIRECTORIES                                      */}
        {/* ═════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'citations' && (
          <CitationsWorklist />
        )}

      </div>

      {/* GMB AI Command Center Modal */}
      <GmbCommandModal
        isOpen={isGmbModalOpen}
        onClose={() => setIsGmbModalOpen(false)}
        office={selectedGmbOffice}
      />

      {/* Полный аудит: окно показывает состояние ПРОГОНА НА СЕРВЕРЕ */}
      <FullAuditModal
        open={auditOpen}
        onClose={() => setAuditOpen(false)}
        onCompleted={() => zaprositPosledniy()}
      />
    </div>
  );
};

export default GrowthWorkspace;
